import { connect } from "react-redux";
import {
    clearAnnotation,
    createAnnotation,
    deleteAnnotation,
    enterEditMode,
    enterViewMode,
    hideMessages,
    nextImage,
    previousImage,
    setAnnotation,
    updateAnnotation,
} from "../actions";
import { ImageAnnotations, ImageAnnotationsProps } from "../components/ImageAnnotations";
import { AnnotationsPartialState } from "../reducers/dtos";
import { getAnnotation, getAnnotationsList, getCurrentImage, hasAnnotations } from "../selectors";

const mapStateToProps = (state: AnnotationsPartialState): Partial<ImageAnnotationsProps> => ({
    annotations: getAnnotationsList(state),
    annotation: getAnnotation(state),
    hasAnnotations: hasAnnotations(state),
    isMessagesShown: state.imageAnnotations.popup.isMessagesShown,
    disabledNavigation: state.imageAnnotations.image.attachmentIds.length < 2,
    attachmentId: state.imageAnnotations.image.attachmentId,
    image: getCurrentImage(state),
});

const mapDispatchToProps: Partial<ImageAnnotationsProps> = {
    setAnnotation,
    clearAnnotation,
    createAnnotation,
    hideMessages,
    updateAnnotation,
    deleteAnnotation,
    enterEditMode,
    enterViewMode,
    previousImage,
    nextImage,
};

export const ImageAnnotationContainer = connect(mapStateToProps, mapDispatchToProps)(ImageAnnotations);
